import { render, staticRenderFns } from "./CategoryRulesTable.vue?vue&type=template&id=0be50474&scoped=true&"
import script from "./CategoryRulesTable.vue?vue&type=script&lang=js&"
export * from "./CategoryRulesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be50474",
  null
  
)

export default component.exports